/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_No_Terms_Selected_ToastInputs */

const en_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No terms selected`)
};

const fr_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun terme selectionne`)
};

const de_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Begriffe ausgewählt`)
};

const it_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun termine selezionato`)
};

const ru_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Термины не выбраны`)
};

const es_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay términos seleccionados`)
};

const zh_cn2_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择任何条款`)
};

const ja_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用語が選択されていません`)
};

const hi_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पद चयनित नहीं`)
};

const pt_pt2_knp_lookup_no_terms_selected_toast = /** @type {(inputs: Knp_Lookup_No_Terms_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum termo selecionado`)
};

/**
* | output |
* | --- |
* | "No terms selected" |
*
* @param {Knp_Lookup_No_Terms_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_no_terms_selected_toast = /** @type {((inputs?: Knp_Lookup_No_Terms_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_No_Terms_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "de") return de_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "it") return it_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "es") return es_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_no_terms_selected_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_no_terms_selected_toast(inputs)
	return en_knp_lookup_no_terms_selected_toast(inputs)
});